import { useEffect, useRef, useState } from 'react';
import Cropper, { Area } from 'react-easy-crop';

import { CropImageSkeleton } from '../CropImageSkeleton/CropImageSkeleton.component';
import { DraggableInput } from '../DraggableInput/DraggableInput.component';
import { FileButton } from '../FileButton/FileButton.component';
import { useCropImageContext } from '../useCropImageContext/useCropImageContext';

import styles from './CropImageSection.module.scss';

export const CropImageSection = () => {
  const { imageUrl, cleanImg, setSavedCroppedAreaPixels, isLoadingImage, onLoadImage } =
    useCropImageContext();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const [firstLoading, setFirstLoading] = useState<boolean>(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const onCropComplete = (_: Area, croppedAreaPixels: Area) => {
    setSavedCroppedAreaPixels(croppedAreaPixels);
  };

  const onRemoveImage = () => {
    if (imageUrl) {
      cleanImg();
      setZoom(1);
    }
  };

  useEffect(() => {
    if (!fileInputRef.current || imageUrl || firstLoading) return;

    fileInputRef.current.click();
    setFirstLoading(true);
  }, [fileInputRef, imageUrl, firstLoading]);

  return (
    <div className={styles.container}>
      {imageUrl && !isLoadingImage ? (
        <div className={styles.container__crop}>
          <Cropper
            image={imageUrl}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
            cropShape='round'
            cropSize={{ width: 292, height: 292 }}
            showGrid={false}
          />
        </div>
      ) : (
        <CropImageSkeleton isLoading={isLoadingImage} />
      )}
      <div className={styles.edit}>
        <FileButton
          inputRef={fileInputRef}
          onLoadImage={onLoadImage}
          onRemoveImage={onRemoveImage}
        />

        {imageUrl && !isLoadingImage && (
          <DraggableInput
            value={zoom}
            minValue={1}
            maxValue={3}
            onChange={setZoom}
            containerProperties={{ maxWidth: '340px', flex: 1 }}
          />
        )}
      </div>
    </div>
  );
};
